import { MenuItem } from "@mui/material";
import React from "react";
import { Checkbox } from "../Checkbox/Checkbox";
import { Enter, Space } from "../Utils/Keys";
/**menu item control that conforms to aria menuitemcheckbox behaviour
 * must be a child component under something with the menu/menubar role
 * see: https://www.w3.org/TR/wai-aria-1.1/#menuitemcheckbox
 *
 * this follows keyboard behaviour laid out here: https://www.w3.org/TR/wai-aria-practices/#menu
 * * arrow key up/down supported
 * * enter actions the row *and* closes the menu,
 * * space actions the row but does not close the menu.
 */
export const MenuItemCheckbox = React.forwardRef((props, ref) => {
    const { checked, setChecked, handleClose, children, ...rest } = props;
    let ariaLabel = props["aria-label"];
    if (!ariaLabel && typeof props.children === "string") {
        ariaLabel = props.children;
    }
    const onClick = (event) => {
        //MenuItem tries to be "helpful" and routes some non click events to the click handler, need to make sure this is actually a click event
        if (event.type === "click") {
            setChecked(!checked);
        }
    };
    const onKeyDown = (event) => {
        switch (event.key) {
            case Enter.key: {
                setChecked(!checked);
                handleClose(); //close on Enter, not on Space - w3.org says so
                break;
            }
            case Space.key: {
                setChecked(!checked);
                break;
            }
        }
    };
    return (React.createElement(MenuItem, { ref: ref, role: "menuitemcheckbox", "aria-checked": checked, "aria-label": ariaLabel, dense: true, onClick: onClick, onKeyDown: onKeyDown, ...rest },
        React.createElement(Checkbox, { displayOnly: true, compact: true, checked: checked, style: { padding: 0, paddingRight: "0.1em" } }),
        children));
});
